import React from 'react';

const LoadingScreen = () => (
  <div className="min-h-screen bg-gradient-to-br from-[#FC7A69]/10 to-[#221E45]/10 flex items-center justify-center">
    <div className="text-center">
      <div className="relative">
        <div className="animate-spin rounded-full h-16 w-16 border-4 border-blue-200 border-t-blue-600 mx-auto mb-4"></div>
        <div className="absolute inset-0 animate-ping rounded-full h-16 w-16 border-4 border-blue-300 opacity-20 mx-auto"></div>
      </div>
      <p className="text-gray-600 font-medium">Loading your dashboard...</p>
    </div>
  </div>
);

export default LoadingScreen;